import React from 'react';
import PropTypes from 'prop-types';
import { MdMenu, MdNotifications, MdOutlineMonetizationOn } from 'react-icons/md';
import { useHistory } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import {
  Badge, Button, Icon, IconButton, Typography,
} from '@material-ui/core';
import {
  Actions, NavigationInfo, Container, ActionsContainer,
} from './toolbarStyles';

import { ActionsNavBar } from '../NavBar/ActionsNavBar';
import { FloatBox } from '../FloatContainer/FloatBox';
import { Notifications } from '../NavBar/actionsNavBarStyles';
import { lerNotificacaoProcessoAtivoService } from '../../services/core/processos/processosRequisicoesService';
import { findQuantidadeAcordosAprovadosAction } from '../../store/theme.actions';

function ToolbarComponent({ minimized, handleChangeMinimize }) {
  const title = useSelector(state => state?.theme?.title || '');
  const quantidadeNotificacoes = useSelector(state => state.theme.quantidadeNotificacoes);
  const quantidadeAutorizacoes = useSelector(state => state.theme.quantidadeAutorizacoes);
  const dadosAcordosAprovados = useSelector(state => state.theme.quantidadeAcordosAprovados || {});
  const quantidadeAcordosAprovados = dadosAcordosAprovados?.qtdeProcessosAtivos || 0;
  const idsProcessoAcordosAprovados = dadosAcordosAprovados?.idsProcessoAtivos || [];
  const nrosAcordo = dadosAcordosAprovados?.nrosAcordo || [];

  const history = useHistory();
  const dispatch = useDispatch();
  const badgeReg = React.useRef();
  const badgeFloatReg = React.useRef();

  const autorizacaoReg = React.useRef();
  const autorizacaoFloatReg = React.useRef();
  const acordosAprovadosReg = React.useRef();
  const acordosAprovadosFloatReg = React.useRef();

  function handleShowNotitications() {
    if (quantidadeNotificacoes > 0) {
      badgeFloatReg.current.handlerShowBox();
    }
  }

  function handleShowAutorizacao() {
    if (quantidadeAutorizacoes > 0) {
      autorizacaoFloatReg.current.handlerShowBox();
    }
  }

  function handleShowAcordosAprovados() {
    if (quantidadeAcordosAprovados > 0) {
      acordosAprovadosFloatReg.current.handlerShowBox();
    }
  }

  function goToProcessos() {
    badgeFloatReg.current.handlerShowBox();
    localStorage.setItem('previousUrl', '/');
    history.push('/processos?notificacao=true');
  }

  function goToAutorizacao() {
    autorizacaoFloatReg.current.handlerShowBox();
    localStorage.setItem('previousUrl', '/');
    history.push('/processos?autorizacao=true');
  }

  function goToAcordosAprovados(idProcesso) {
    lerNotificacaoProcessoAtivoService(idProcesso)
      .then(() => {
        dispatch(findQuantidadeAcordosAprovadosAction());
      })
      .catch(() => {});
    acordosAprovadosFloatReg.current.handlerShowBox();
    localStorage.setItem('previousUrl', '/');
    history.push(`/processos?numeroProcesso=${idProcesso}`);
  }

  return (
    <Container>
      <NavigationInfo minimized={minimized}>
        <button
          type="button"
          onClick={handleChangeMinimize}
        >
          <MdMenu size={24} />
        </button>
        <Typography>{title}</Typography>
      </NavigationInfo>
      <Actions>
        <IconButton
          color="inherit"
          onClick={handleShowAcordosAprovados}
          ref={acordosAprovadosReg}
        >
          <Badge badgeContent={quantidadeAcordosAprovados} color="error">
            <Icon>comment</Icon>
          </Badge>
        </IconButton>
        <FloatBox
          ref={acordosAprovadosFloatReg}
          parentRef={acordosAprovadosReg}
        >
          <Notifications
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              paddingTop: 0,
              paddingRight: '4px',
              maxHeight: '185px',
              minHeight: 0,
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            {idsProcessoAcordosAprovados.map((idProcesso, index) => (
              <div key={idProcesso} style={{ width: '100%' }}>
                <Button
                  style={{
                    textTransform: 'capitalize',
                    fontSize: '14px',
                    paddingLeft: '0',
                    fontWeight: 'normal',
                    width: '100%',
                    justifyContent: 'flex-start',
                  }}
                  onClick={() => goToAcordosAprovados(idProcesso)}
                >
                  <p>{`A proposta nº ${nrosAcordo?.[index] || ''} do Processo nº ${idProcesso} foi avaliada.`}</p>
                </Button>
              </div>
            ))}

          </Notifications>
        </FloatBox>
        <IconButton
          ref={autorizacaoReg}
          color="inherit"
          onClick={handleShowAutorizacao}
        >
          <Badge badgeContent={quantidadeAutorizacoes} color="error">
            <MdOutlineMonetizationOn color="black" size={24} />
          </Badge>
        </IconButton>
        <FloatBox
          ref={autorizacaoFloatReg}
          parentRef={autorizacaoReg}
        >
          <Notifications>
            <div>
              <Button
                style={{
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  paddingLeft: '0',
                  fontWeight: 'normal',
                }}
                onClick={() => goToAutorizacao()}
              >
                <p>Você tem proposta aguardando aprovação.</p>
              </Button>
            </div>

          </Notifications>
        </FloatBox>

        <IconButton
          ref={badgeReg}
          color="inherit"
          onClick={handleShowNotitications}
        >
          <Badge badgeContent={quantidadeNotificacoes} color="error">
            <MdNotifications color="black" size={24} />
          </Badge>
        </IconButton>
        <FloatBox
          ref={badgeFloatReg}
          parentRef={badgeReg}
        >
          <Notifications>
            <div>
              <Button
                style={{
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  paddingLeft: '0',
                  fontWeight: 'normal',
                }}
                onClick={() => goToProcessos()}
              >
                <p>Você tem Requisições aguardando.</p>
              </Button>
            </div>

          </Notifications>
        </FloatBox>

        <ActionsContainer>
          <ActionsNavBar />
        </ActionsContainer>
      </Actions>
    </Container>
  );
}

ToolbarComponent.propTypes = {
  minimized: PropTypes.bool.isRequired,
  handleChangeMinimize: PropTypes.func.isRequired,
};

export const Toolbar = React.memo(ToolbarComponent);
